import { Stack } from "@mui/material";
import type { ReactNode } from "react";
import { LeaderboardEntry } from "Components/Loyalty/Shared/Leaderboard/LeaderboardEntry";
import { LeaderboardSkeleton } from "Components/Loyalty/Shared/Leaderboard/LeaderboardSkeleton";
import type { LoyaltyLeaderboardEntry } from "Components/Loyalty/Shared/Leaderboard/types";
import { SectionTitle } from "Components/Loyalty/Shared/SectionTitle/SectionTitle";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  title: string;
  items: Array<LoyaltyLeaderboardEntry> | undefined;
  isLoading: boolean;
  isError: boolean;
  scoreIcon: ReactNode;
};

export const Leaderboard = ({
  title,
  items,
  isLoading,
  isError,
  scoreIcon,
}: Props) => {
  const { t } = useResource();

  if (isLoading) {
    return <LeaderboardSkeleton title={title} />;
  }

  if (isError || !items) {
    return (
      <Stack gap={4}>
        <SectionTitle>{title}</SectionTitle>
        <ErrorText>{t(Resources.Error.Error)}</ErrorText>
      </Stack>
    );
  }

  return (
    <Stack gap={4}>
      <SectionTitle>{title}</SectionTitle>
      <Stack gap={2}>
        {items.map((entry) => (
          <LeaderboardEntry
            key={entry.partyPublicId ?? entry.rank}
            entry={entry}
            anonymousLabel={t(Resources.Common.AnonymousUser)}
            scoreIcon={scoreIcon}
          />
        ))}
      </Stack>
    </Stack>
  );
};
